import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import ContentWrapper from "../ContentWrapper";
import Block from "../Block";
import Column from "../Column";
import markdown from "../../lib/remark";
import LinkedIn from "../assets/LinkedIn";
import { Link } from "gatsby";
import H3 from "../Headers/H3";

const propTypes = {
    member: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string
        })
    ).isRequired,
    teamName: PropTypes.string.isRequired,
    viewAsList: PropTypes.bool
};

const defaultProps = {
    viewAsList: false
};

export default function Team({
    member,
    className,
    teamName,
    showContactButton,
    viewAsList
}) {
    const layout = {
        flexContainer: classnames({
            "flex  flex-wrap -mx-8  justify-between": !viewAsList
        }),
        flexContainerReversed: classnames({
            "flex-row-reverse": true
        }),
        memberContainer: classnames({
            "w-full  sm:w-1/2 md:w-1/2  lg:w-1/4  px-8  mb-8": !viewAsList,
            "md:flex  mb-8": viewAsList
        }),
        photo: classnames({
            "max-w-full": true,
            "w-full": !viewAsList
        }),
        infoContainer: classnames({
            "text-center  md:text-left": viewAsList
        }),
        imageContainer: classnames({
            "relative": !viewAsList,
            "min-w-250 text-center md:text-left": viewAsList
        })
    };

    const view = member.map((person, index) => {
        const extraContainerClasses = viewAsList && index % 2 ? " flex-row-reverse" : "";
        const extraInfoContainerClasses =  classnames({
            " text-center  md:text-right  pr-8  pl-0": viewAsList && index % 2,
            " pr-0  pl-8": !(viewAsList && index % 2)
        })

        const extraFunctionClasses = classnames({
            "text-center  md:text-left": viewAsList
        })

        return (
            <div
                key={person.name}
                className={layout.memberContainer.concat(extraContainerClasses)}
            >
                <div className={layout.imageContainer}>
                    {!viewAsList && person.linkedin && (
                        <div className="absolute pin-b pin-l ml-2 mb-2">
                            <a href={person.linkedin}>
                                <LinkedIn className="text-sky" width={30} />
                            </a>
                        </div>
                    )}
                    <img
                        alt={person.name}
                        title={person.name}
                        className={layout.photo}
                        src={`${person.photo.url}?w=250&auto=compress,format`}
                    />
                </div>

                <div className={`mt-2 ${layout.infoContainer.concat(extraInfoContainerClasses)}`}>
                    <div className="text-sky  text-xl  font-bold">
                        {person.name}
                    </div>
                    <div
                        className={`text-indigo ${extraFunctionClasses}`}
                        dangerouslySetInnerHTML={markdown(person.function)}
                    />
                    {viewAsList && (
                        <div className="cms-content  mt-4  text-justify">
                            {person.description}
                        </div>
                    )}
                </div>
            </div>
        );
    });

    return (
        <ContentWrapper className={`${className}`}>
            <Block>
                <Column>
                    <H3>{teamName}</H3>
                </Column>
            </Block>
            <Block>
                <Column column="w-full">
                    {!viewAsList && (
                        <div className={layout.flexContainer}>{view}</div>
                    )}

                    {viewAsList && view}

                    {showContactButton && (
                        <div className="text-center  cms-content">
                            <a href="mailto:info@superseton.com" className="button">
                                Get in touch
                            </a>
                        </div>
                    )}
                </Column>
            </Block>
        </ContentWrapper>
    );
}

Team.propTypes = propTypes;
Team.defaultProps = defaultProps;
